import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import FormControl from '@material-ui/core/FormControl';

import { theme } from '../styles/theme';
import { bride } from '../services/api';
import {
  Button,
  MaterialSelect,
  MaterialInputLabel,
  MaterialMenuItem,
  MaterialInput,
  ConfirmModal,
} from './';
import { medias } from '../utils/mediaQueries';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const RadioSection = styled.fieldset`
  display: flex;
  flex-direction: row;
  justify-content: center;
  border: none;
  width: 90%;
  padding: 0;
  margin: 1em 0;

  @media ${medias.phoneMax} {
    flex-direction: column;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.5em;
`;

const RadioInput = styled.input`
  margin: 0;
  margin-right: 0.3em;
`;

const RadioLabel = styled.label`
  color: ${theme.colors.text_heading};
  font-size: ${theme.fontSizeSm}px;
  text-align: center;
  margin: 0;
`;

const ContactLabel = styled.span`
  font-size: ${theme.fontSizeSm}px;
  color: ${theme.colors.grey3};
  font-weight: 300;
  margin-right: 1em;
`;

const StyledFormControl = styled(props => <FormControl {...props} />)`
  width: 90%;
`;

const FullButton = styled(props => <Button {...props} />)`
  background-color: ${props =>
    props.selected ? theme.colors.white : theme.colors.text_heading};
  color: ${props =>
    props.selected ? theme.colors.text_heading : theme.colors.white};
  border-color: ${theme.colors.text_heading};
  width: 100%;
  margin: 0 1em ${({ confirm }) => (confirm ? '1em' : '0')} 1em;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  text-align: center;
  font-size: ${theme.fontSizeSm}px;
  width: 90%;
`;

const SupplierBudgetForm = ({ supplierData, selectedEvent }) => {
  const [contact, setContact] = useState(0);
  const [message, setMessage] = useState('');
  const [segment, setSegment] = useState('');
  const [alreadyRequestBudget, setAlreadyRequestBudget] = useState(false);

  const { nomeDivulgacao, segmentos } = supplierData;

  const onBudgetRequest = async () => {
    const body = {
      userId: Number(localStorage.userId),
      event: Number(selectedEvent),
      contact,
      message,
      supplierName: nomeDivulgacao,
      chosenSegment: segment,
    };

    const response = await bride.brideSupplierBudget(body);

    return response.ok && response.data
      ? toast.error('Orçamento solicitado com sucesso!')
      : toast.error('Não foi possivel solicitar o orçamento!');
  };

  const onClickConfirm = async () => {
    const event = Number(selectedEvent);
    const check = await bride.brideSupplierBudgetCheck(
      event,
      nomeDivulgacao,
      segment
    );

    !check.ok || !check.data
      ? onBudgetRequest()
      : setAlreadyRequestBudget(true);
  };

  const renderLoggedForm = () => (
    <>
      <p>Solicitar orçamento</p>
      <MaterialInput
        style={{ width: '90%' }}
        label="Mensagem"
        value={message}
        onChange={event => setMessage(event.target.value)}
      />
      <StyledFormControl>
        <MaterialInputLabel htmlFor="codSegment">Segmento</MaterialInputLabel>
        <MaterialSelect
          style={{ width: '100%' }}
          name="codSegment"
          onChange={event => setSegment(event.target.value)}
          value={segment}
          inputProps={{
            name: 'codSegment',
            id: 'codSegment',
          }}
        >
          {segmentos.length > 0 &&
            segmentos.map(item =>
              item ? (
                <MaterialMenuItem
                  key={item.codSegmento}
                  value={item.codSegmento}
                >
                  {' '}
                  {item.Segmento}{' '}
                </MaterialMenuItem>
              ) : (
                ''
              )
            )}
        </MaterialSelect>
      </StyledFormControl>
      <RadioSection>
        <ContactLabel>Quero ser contactado:</ContactLabel>
        <RadioGroup>
          <RadioInput
            type="radio"
            onChange={() => setContact(1)}
            value="phone"
            checked={contact === 1}
          />
          <RadioLabel>Telefone</RadioLabel>
        </RadioGroup>
        <RadioGroup>
          <RadioInput
            type="radio"
            onChange={() => setContact(3)}
            value="whatsapp"
            checked={contact === 3}
          />
          <RadioLabel>Whatsapp</RadioLabel>
        </RadioGroup>
        <RadioGroup>
          <RadioInput
            type="radio"
            onChange={() => setContact(2)}
            value="mail"
            checked={contact === 2}
          />
          <RadioLabel>E-mail</RadioLabel>
        </RadioGroup>
      </RadioSection>
      <ButtonsContainer>
        <FullButton confirm text="CONFIRMAR" click={onClickConfirm} />
      </ButtonsContainer>
    </>
  );

  return (
    <Wrapper>
      {renderLoggedForm()}
      <ConfirmModal
        opened={alreadyRequestBudget}
        marginTop={'400px'}
        closeModal={() => setAlreadyRequestBudget(false)}
        onClickConfirm={onBudgetRequest}
        text="Você já mandou um orçamento para esse fornecedor, deseja enviar outro?"
      />
    </Wrapper>
  );
};

SupplierBudgetForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onClickButton: PropTypes.func.isRequired,
  opened: PropTypes.bool.isRequired,
};

export default SupplierBudgetForm;
